// import { ThemeProvider } from "styled-components";
// import GlobalStyle from "./globalStyles";
// import { lightTheme } from "./components/Themes";
// import { Route, Routes, useLocation } from "react-router-dom";

// // Components
// import Main from './components/Main';
// import AboutPage from './components/AboutPage';
// import BlogPage from './components/BlogPage';
// import WorkPage from './components/WorkPage';
// import MySkillsPage from './components/MySkillsPage';
// import Contact from "./components/Contact";
// import { AnimatePresence } from "framer-motion";
// import SoundBar from "./subComponents/SoundBar";

// function App() {
//   const location = useLocation();

//   return (
//     <>
//       <GlobalStyle />

//       <ThemeProvider theme={lightTheme}>
//         <SoundBar />

//         {/* Framer Motion animation on page change */}
//         <AnimatePresence mode="sync"> 
//           <Routes location={location} key={location.pathname}> 
//             <Route exact path="/" element={<Main />} />
//             <Route exact path="/about" element={<AboutPage />} />
//             <Route exact path="/blog" element={<BlogPage />} />
//             <Route exact path="/work" element={<WorkPage />} />
//             <Route exact path="/skills" element={<MySkillsPage />} />
//             <Route exact path="/contact" element={<Contact />} />
//           </Routes>
//         </AnimatePresence>
//       </ThemeProvider>
//     </>
//   );
// }

// export default App;






import { ThemeProvider } from "styled-components";
import GlobalStyle from "./globalStyles";
import { lightTheme } from "./components/Themes";
import { Route, Routes, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

// Components
import Main from './components/Main';
import AboutPage from './components/AboutPage';
import BlogPage from './components/BlogPage';
import WorkPage from './components/WorkPage';
import MySkillsPage from './components/MySkillsPage';
import Contact from "./components/Contact";
import ProjectDetails from './components/ProjectDetails';
import { AnimatePresence } from "framer-motion";
import SoundBar from "./subComponents/SoundBar";

function App() {
  const location = useLocation();

  return (
    <>
      <Helmet>
        <title>Edward Ndiyo's Portfolio</title>
        <meta name="description" content="Explore Edward Ndiyo's portfolio." />
        <meta property="og:title" content="Edward Ndiyo's Portfolio" />
        <meta property="og:description" content="Explore Edward Ndiyo's portfolio." />
        <meta property="og:image" content="https://pbs.twimg.com/profile_banners/1091009481163591680/1733936452/1500x500" />
        <meta property="og:url" content="https://ndiyo-portfolio.vercel.app/" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Edward Ndiyo's Portfolio" />
        <meta name="twitter:description" content="Explore Edward Ndiyo's portfolio." />
        <meta name="twitter:image" content="https://pbs.twimg.com/profile_banners/1091009481163591680/1733936452/1500x500" />
      </Helmet>

      <GlobalStyle />

      <ThemeProvider theme={lightTheme}>
        <SoundBar />

        {/* Framer Motion animation on page change */}
        <AnimatePresence mode="sync"> 
          <Routes location={location} key={location.pathname}> 
            <Route exact path="/" element={<Main />} />
            <Route exact path="/about" element={<AboutPage />} />
            <Route exact path="/blog" element={<BlogPage />} />
            <Route exact path="/work" element={<WorkPage />} />
            <Route exact path="/skills" element={<MySkillsPage />} />
            <Route exact path="/contact" element={<Contact />} />
            <Route path="/work/:id" element={<ProjectDetails />} />
          </Routes>
        </AnimatePresence>
      </ThemeProvider>
    </>
  );
}

export default App;
